import { Button, Icon, Tag, Popover, Classes } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useGridFiltersModule } from "./useGridFiltersModule";
import { PredicateModel } from "@syncfusion/ej2-react-grids";
import { GridFilterSettings } from "../../types/GridFilterSettings";

export interface GridFiltersComponentProps {
  gridKey: string;
  filtersCount: number;
  filterSettings?: GridFilterSettings;
  rawFilterSettings?: PredicateModel[];
  removeFilter: (field: string) => void;
  clearFilters: (gridFilterSettings?: GridFilterSettings) => void;
  removeSort: (field: string) => void;
}
const GridFiltersComponent: React.FC<GridFiltersComponentProps> = (props) => {
  const { getSortDetails, getFilterDetails } = useGridFiltersModule();

  return (
    <div className="grid-filters-module">
      {props.filtersCount > 0 && !!props.filterSettings && (
        <div className="grid-filters">
          <Popover
            interactionKind="hover"
            placement="left"
            minimal={true}
            portalClassName="grid-filters-module"
            popoverClassName={Classes.POPOVER_CONTENT_SIZING}
            content={
              <div className="grid-filters-details">
                <ul className="grid-filters-details-list">
                  {getSortDetails(
                    props.filterSettings.rawColumnSettings,
                    props.filterSettings.rawSortSettings
                  )?.map((sort) => (
                    <li key={`sort-${sort.field}`}>
                      <Tag
                        fill={false}
                        onRemove={() => props.removeSort(sort.field)}
                      >
                        {sort.details}
                        <Icon
                          iconSize={10}
                          icon={
                            sort.direction === "Ascending"
                              ? IconNames.ARROW_UP
                              : IconNames.ARROW_DOWN
                          }
                        />
                      </Tag>
                    </li>
                  ))}
                  {getFilterDetails(
                    props.filterSettings?.rawFilterSettings
                  )?.map((filter) => (
                    <li key={`filter-${filter.field}`}>
                      <Tag
                        fill={false}
                        onRemove={() => props.removeFilter(filter.field)}
                      >
                        {filter.details}
                      </Tag>
                    </li>
                  ))}
                </ul>
                <Button
                  className="grid-filters-details-clear"
                  minimal={true}
                  text="Clear All"
                  onClick={() => props.clearFilters()}
                />
              </div>
            }
          >
            <div className="grid-filters-count">
              <Button className="grid-filters-count-target" title="Clear All">
                <Icon
                  className="grid-filters-count-icon"
                  icon={IconNames.FILTER_LIST}
                />
                <span className="grid-filters-count-text">
                  {`${props.filtersCount} Filter(s)`}
                </span>
                <Icon
                  className="grid-filters-count-clear"
                  icon={IconNames.CROSS}
                  onClick={() => props.clearFilters()}
                />
              </Button>
            </div>
          </Popover>
        </div>
      )}
    </div>
  );
};

export const GridFilters = GridFiltersComponent;
export default GridFilters;
